import {createApp} from 'vue'
import App from './App.vue'
import {router} from "@/router";
import './assets/styles/reset.css'
import './assets/styles/border.css'
// Toast
import 'vant/es/toast/style';

// Dialog
import 'vant/es/dialog/style';
import { Lazyload } from 'vant';
// Notify
import 'vant/es/notify/style';

// ImagePreview
import 'vant/es/image-preview/style';
import moment from "moment";


import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';

// highlightjs
import hljs from 'highlight.js';

VMdPreview.use(githubTheme, {
    Hljs: hljs,
});


export const app = createApp(App);
//确保 _use_ 路由实例
//整个应用支持路由。
app.use(router)
app.use(VMdPreview);
app.use(Lazyload);
// 调试顺畅
if (process.env.NODE_ENV === 'development') {
    // if ('__VUE_DEVTOOLS_GLOBAL_HOOK__' in window) {
        // 这里__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue赋值一个createApp实例
        window.VueINS = app
    // }
    app.config.devtools = true
}
app.mount('#app')
moment.locale();